(function () {
  'use strict';

  function ProgressTrackerController ($state, $location, Common, progressTrackerFactory) {
    const vm = this;
    const stages = ['landing', 'recipients', 'whereTo', 'message', 'payment', 'receipt'];
    let states;

    function isPreviousStage (stage) {
      return stages.indexOf(stage) < stages.indexOf(vm.stage);
    }

    function isCurrentStage (stage) {
      return vm.stage === stage;
    }

    function checkPayment () {
      return progressTrackerFactory.checkAll();
    }

    function checkRecipients () {
      return progressTrackerFactory.checkRecipients();
    }

    function checkMessage () {
      return progressTrackerFactory.checkMaterial() && checkWhereTo() && progressTrackerFactory.checkWhereTo();
    }

    function checkWhereTo () {
      return progressTrackerFactory.checkProduct() && progressTrackerFactory.checkRecipients();
    }

    function setCorrectWhereToState () {
      let state = 'main.whereTo';
      const addressType = Common.get('recipients.addressType', 'FILE');

      if (addressType === 'ODR') {
        state = 'main.odrWhereTo';
      }

      return state;

    }

    function goTo (state, stateChecker) {
      if (state && stateChecker && states[stateChecker]() && !vm.isSubmitting) {
        if (state === 'main.whereTo') {
          state = setCorrectWhereToState();
        }

        $state.go(state);
      }

      if (!state && !vm.isSubmitting) {
        let landingState = 'main.landing';

        if (Common.get('serviceType', '').indexOf('admail') === 0) {
          landingState = 'main.admail';
        }

        $state.go(landingState);
      }

    }

    function checkState (state) {
      return states[state]();
    }

    function checkIfDone (checker) {
      return progressTrackerFactory[checker]();
    }

    function checkRecipientsInputs () {
      return progressTrackerFactory.checkRecipientsInputs();
    }

    function checkProductOnClick () {
      return progressTrackerFactory.checkProductOnClick();
    }

    function activate () {
      // bindings:
      states = {
        'payment': checkPayment,
        'recipients': checkRecipients,
        'message': checkMessage,
        'whereTo': checkProductOnClick,
        'recipientsCheckForm': checkRecipientsInputs
      };

      //methods
      vm.isCurrentStage = isCurrentStage;
      vm.isPreviousStage = isPreviousStage;
      vm.goTo = goTo;
      vm.checkState = checkState;
      vm.checkIfDone = checkIfDone;
    }

    activate();
  }

  angular.module('web2print')
    .controller('ProgressTrackerController', ProgressTrackerController);

  ProgressTrackerController.$inject = ['$state', '$location', 'Common', 'progressTrackerFactory'];
})();
